<template>
    <div>
      <section >
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Attendee Quota</span>
            <div style="font-size:0.75rem; color:#aaa;"></div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <!-- <vs-input
              class="w-full"
              v-model="basicForm.max_attendee"
              onkeypress="return /^[0-9]/i.test(event.key)"
            /> -->
            <vs-input
              class="w-full"
              v-model="basicForm.max_attendee"
              placeholder=""
              onkeypress="return /^[0-9]/i.test(event.key)"
            />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Names must be in English only</span>
            <div style="font-size:0.75rem; color:#aaa;">
              This is to avoid registrations info in other languages
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <ul class="demo-alignment">
              <li>
                <vs-radio
                  vs-name="radios-engnameonly"
                  v-model="basicForm.engnameonly"
                  :vs-value="1"
                  >Yes</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  vs-name="radios-engnameonly"
                  v-model="basicForm.engnameonly"
                  :vs-value="0"
                  >No</vs-radio
                >
              </li>
            </ul>
          </div>
        </div>

        <div class="vx-row mb-6">
        <!-- v-if="
            eventFieldsPermission.find((x) => x.key == `freecode`) &&
            eventFieldsPermission
              .find((x) => x.key == `freecode`)
              .actions.find((x) => x.type == `view`)
              .roles.includes(role)
          " -->
          <div class="vx-col sm:w-1/3 w-full">
            <span>Code to auto approve orders</span>
            <div style="font-size:0.75rem; color:#aaa;">
              Enter multiple codes separated by comma
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-textarea
              rows="3"
              class="w-full"
              v-model="basicForm.freecode"
            />
            <!-- v-if="
                eventFieldsPermission
                  .find((x) => x.key == `freecode`)
                  .actions.find((x) => x.type == `view`)
                  .roles.includes(role)
              " -->
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Weight</span>
            <div style="font-size:0.75rem; color:#aaa;"></div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input
              class="w-full"
              v-model="basicForm.weight"
              placeholder=""
              onkeypress="return /^[0-9]/i.test(event.key)"
              onpaste="return false"
            />
          </div>
        </div>

        <hr>

        <h1 class="py-5">Payments</h1>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Credit Card</span>
            <div style="font-size:0.75rem; color:#aaa;"></div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <ul class="demo-alignment">
              <li>
                <vs-radio
                  vs-name="radios-pay_creditcard"
                  v-model="basicForm.pay_creditcard"
                  :vs-value="1"
                  >Show</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  vs-name="radios-pay_creditcard"
                  v-model="basicForm.pay_creditcard"
                  :vs-value="0"
                  >Hide</vs-radio
                >
              </li>
            </ul>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Bank Transfer</span>
            <div style="font-size:0.75rem; color:#aaa;"></div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <ul class="demo-alignment">
              <li>
                <vs-radio
                  vs-name="radios-pay_transfer"
                  v-model="basicForm.pay_transfer"
                  :vs-value="1"
                  >Show</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  vs-name="radios-pay_transfer"
                  v-model="basicForm.pay_transfer"
                  :vs-value="0"
                  >Hide</vs-radio
                >
              </li>
            </ul>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Payment Deadline</span>
            <div style="font-size:0.75rem; color:#aaa;">
              Deadline for making the payment in minutes
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <select class="form-control" v-model="basicForm.pay_deadline">
              <option
                v-for="(item, index) in deadlineOptions"
                :value="item.value"
                :key="index"
              >
                {{ item.text }}
              </option>
            </select>
          </div>
        </div>

        <hr>

        <h1 class="py-5">Integration</h1>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Zapier</span>
            <div style="font-size:0.75rem; color:#aaa;"></div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <ul class="demo-alignment">
              <li>
                <vs-radio
                  vs-name="radios-zapier_status"
                  v-model="basicForm.zapier_status"
                  :vs-value="1"
                  >Yes</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  vs-name="radios-zapier_status"
                  v-model="basicForm.zapier_status"
                  :vs-value="0"
                  >No</vs-radio
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="vx-row mb-6" v-if="basicForm.zapier_status == 1">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Zapier Webhook</span>
            <div style="font-size:0.75rem; color:#aaa;"></div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input
              v-validate="{required: basicForm.zapier_status === 1, regex:/^[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=,]*)$/}"
              name="zapier_webhook"
              class="w-full"
              v-model="basicForm.zapier_webhook"
              placeholder=""
            />
            <span class="text-danger text-sm" v-show="errors.has('zapier_webhook')">
                {{ errors.first("zapier_webhook") }}
            </span>
          </div>
        </div>

        <!-- <div class="vx-row mb-6" v-if="role == 'so-admin'">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Remark</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-textarea rows="3" class="w-full" v-model="basicForm.remark" />
          </div>
        </div> -->

        <hr>

        <h1 class="py-5">Revenue Settlement</h1>

        <section>
          <div class="vx-row mb-6">
            <!-- v-if="
              eventFieldsPermission.find((x) => x.key == `fee`) &&
              eventFieldsPermission
                .find((x) => x.key == `fee`)
                .actions.find((x) => x.type == `view`)
                .roles.includes(role)
            " -->
            <div class="vx-col sm:w-1/3 w-full">
              <span>Fee</span>
              <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                class="w-full"
                v-model="basicForm.fee"
                placeholder=""
                onkeypress="return /^[0-9]/i.test(event.key)"
                onpaste="return false"
              />
              <!-- v-if="
                eventFieldsPermission
                  .find((x) => x.key == `fee`)
                  .actions.find((x) => x.type == `view`)
                  .roles.includes(role)
              " -->
            </div>
          </div>

          <div class="vx-row mb-6">
            <!-- v-if="
              eventFieldsPermission.find((x) => x.key == `int_invoiceno`) &&
              eventFieldsPermission
                .find((x) => x.key == `int_invioceno`)
                .actions.find((x) => x.type == `view`)
                .roles.includes(role)
            " -->
            <div class="vx-col sm:w-1/3 w-full">
              <span>Invoice No.</span>
              <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                class="w-full"
                v-model="basicForm.int_invoiceno"
                placeholder=""
              />
              <!-- v-if="
                  eventFieldsPermission
                    .find((x) => x.key == `int_invoiceno`)
                    .actions.find((x) => x.type == `view`)
                    .roles.includes(role)
                " -->
            </div>
          </div>

          <div class="vx-row mb-6">
            <!-- v-if="
              eventFieldsPermission.find((x) => x.key == `int_invoicedate`) &&
              eventFieldsPermission
                .find((x) => x.key == `pro_name`)
                .actions.find((x) => x.type == `view`)
                .roles.includes(role)
            " -->
            <div class="vx-col sm:w-1/3 w-full">
              <span>Invoice Date</span>
              <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <flat-pickr
                  :config="configdateTimePicker"
                  v-model="basicForm.int_invoicedate"
                  placeholder="Date Time"
                />
                <!-- v-if="
                    eventFieldsPermission
                      .find((x) => x.key == `int_invoicedate`)
                      .actions.find((x) => x.type == `view`)
                      .roles.includes(role)
                  " -->
            </div>
          </div>

          <!-- <div class="vx-row mb-6">
            v-if="
              eventFieldsPermission.find((x) => x.key == `int_remark`) &&
              eventFieldsPermission
                .find((x) => x.key == `int_remark`)
                .actions.find((x) => x.type == `view`)
                .roles.includes(role)
            "
            <div class="vx-col sm:w-1/3 w-full">
              <span>Remark</span>
              <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-textarea
                rows="3"
                class="w-full"
                v-model="basicForm.int_remark"
              />
              v-if="
                  eventFieldsPermission
                    .find((x) => x.key == `int_remark`)
                    .actions.find((x) => x.type == `view`)
                    .roles.includes(role)
                "
            </div>
          </div> -->
        </section>

        <hr>

        <h1 class="py-5">Child Sessions</h1>

        <section>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Child Sessions</span>
              <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <ul class="demo-alignment">
                <li>
                  <vs-radio
                    vs-name="radios-enable_child_sessions"
                    v-model="basicForm.enable_child_sessions"
                    vs-value="1"
                    >Enabled</vs-radio
                  >
                </li>
                <li>
                  <vs-radio
                    vs-name="radios-enable_child_sessions"
                    v-model="basicForm.enable_child_sessions"
                    vs-value="0"
                    >Disabled</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>
        </section>

        <hr>

        <h1 class="py-5">Note</h1>

        <section>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Notes</span>
              <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-textarea
                rows="3"
                class="w-full"
                v-model="basicForm.remark"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Notes (Internal)</span>
              <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-textarea
                rows="3"
                class="w-full"
                v-model="basicForm.int_remark"
              />
            </div>
          </div>
        </section>

        <hr>

      <section style="color:red;">
        <h1 class="py-5" style="color:red;">Danger Zone</h1>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Delete Event</span>
            <div style="font-size:0.75rem; color:red;">
              Permanently delete this event
            </div>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-button
              class="mr-3 mb-2"
              type="border"
              @click="confirmDeleteDialog = true"
              >Delete Event
            </vs-button>
          </div>
        </div>
      </section>
      <vs-divider></vs-divider>
      <div class="vx-row pt-2 mt-0">
        <div class="vx-col w-full ml-auto">
          <vs-button class="mr-3 mb-2" @click="submitAdvance">Save </vs-button>

          <vs-button class="mr-3 mb-2" type="border" @click="canceled">Cancel </vs-button>
        </div>
      </div>
    </section>

    <vs-popup title="Delete Event?" :active.sync="confirmDeleteDialog">
      <div style="min-height: 100px" class="m-5">
        Are you sure you want to delete the
        <strong>{{ event.pro_name }}</strong> event? This action cannot be
        undone.
      </div>
      <vs-divider />
      <div class="text-right">
        <vs-button
          style="display:inline-block;"
          class="mr-2"
          @click="submitDelete"
          >Delete</vs-button
        >
        <vs-button
          class="mr-3 mb-2"
          type="border"
          @click="confirmDeleteDialog = false"
          >Cancel
        </vs-button>
      </div>
    </vs-popup>
    </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
import Service from "@/services"

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";;

import { advanceForm, basicForm } from "@/utils/eventForm";
import { eventFieldsPermission } from "@/utils/FieldsPermission";

export default {
  components: {
    flatPickr
  },
  props: {
    event: null,
    role: null,
    advanceForm: advanceForm,
    basicForm: basicForm,
    folder: null,
    eventLogInfo: null
  },
  data() {
    return {
      eventFieldsPermission: eventFieldsPermission,
      confirmDeleteDialog: false,
      deadlineOptions: [
        { text: "1 Day", value: 1440 },
        { text: "12 Hours", value: 720 },
        { text: "1 Hour", value: 60 },
        { text: "45 Minutes", value: 45 },
        { text: "30 Minutes", value: 30 },
        { text: "15 Minutes", value: 15 }
      ],
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "Y-m-d H:i"
      },
    };
  },
  watch: {
    'eventLogInfo'(val) {
      console.log(val, 'object')
    },
    'event'(val) {
      console.log(val, 'event')
    }
  },
  methods: {
    submitDelete() {
      this.$vs.loading();

      const data = {
        ...this.basicForm,
        e: this.folder,
        trash_status: 1
      }

      Service.Event.update(data).then(res => {
        if (res.success) {
          const s = this.$route.query.s
          const e = this.$route.query.e

          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: "Delete complete.",
            color: "success"
          });
          this.isEditSlug = false;
          this.confirmDeleteDialog = false;

          // this.$router.push("/events/" + this.basicForm.slug + "/view");
          this.logout()
        }
      });
    },
    logout() {
      this.$store.dispatch("Auth/logout").then(() => {
        this.$store.dispatch("Utility/logout").then(() => {
          this.$store.dispatch("Event/logout").then(() => {
            this.$router.push("/login").catch(() => {});
          });
        });
      });
    },
    submitAdvance() {
      this.advanceForm.e = this.folder;
      // console.log(this.basicForm.int_invoicedate, 'date')
      if (this.basicForm.int_invoicedate === "Invalid date" ) {
        this.basicForm.int_invoicedate = moment(
          this.basicForm.int_invoicedate).format("YYYY-MM-DD HH:mm");
      }
      // console.log(this.basicForm.int_invoicedate, 'date after')

      const data = {
        ...this.basicForm,
        pay_creditcard: (this.eventLogInfo.pay_creditcard === null && this.basicForm.pay_creditcard === 1) ? null: this.basicForm.pay_creditcard ,
        pay_transfer: (this.eventLogInfo.pay_transfer === null && this.basicForm.pay_transfer === 1) ? null: this.basicForm.pay_transfer ,
        freecode: this.basicForm.freecode === ''? 'null': this.basicForm.freecode,
        remark: this.basicForm.remark === ''? 'null': this.basicForm.remark,
        fee: this.basicForm.fee === ''? Number(0.00): this.basicForm.fee,
        int_invoiceno: this.basicForm.int_invoiceno === ''? 'null': this.basicForm.int_invoiceno,
        int_remark: this.basicForm.int_remark === ''? 'null': this.basicForm.int_remark,
        zapier_webhook: this.basicForm.zapier_webhook === ''? 'null': this.basicForm.zapier_webhook,
        fields_status: this.event.fields_status === null ? null: this.basicForm.fields_status

      }

      this.$vs.loading();

      Service.Event.update(data)
        .then(res => {
          if (res.success) {
            this.$vs.notify({
              title: "Success",
              text: "Update complete.",
              color: "success"
            });
            location.reload();
          }
          this.$vs.loading.close();
          // location.reload()
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    },
    canceled() {
      this.$router.push(`/dash`)
    }
  },
  mounted() {
    console.log(this.eventLogInfo.pay_creditcard ,'object');
    console.log(this.event ,'event');
  }
};
</script>
